'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _ = require('../');function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}exports.default =

function (properties) {return (
    _react2.default.createElement(_.OMAccordion, {
        titleValue: properties.title,
        className: properties.className,
        onOpen: properties.onOpen,
        onClose: properties.onClose,
        accordionOpen: properties.isActive,
        afterInitialOpen: properties.afterInitialOpen },

      _react2.default.createElement(_.PlainHtml, { content: properties.content })));};module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/AnchorList/ListItem.js
// module id = 2610
// module chunks = 0